import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PrinterHistoryModal = ({ isOpen, onClose, printer }) => {
  if (!isOpen || !printer) return null;

  const mockHistory = [
    {
      id: 1,
      jobName: "Miniatura de Dragão",
      startTime: "2024-10-30 14:30",
      endTime: "2024-10-30 18:45",
      duration: "4h 15m",
      filamentUsed: "45g",
      filamentType: "PLA Vermelho",
      status: "completed",
      cost: "R$ 12,50"
    },
    {
      id: 2,
      jobName: "Suporte para Celular",
      startTime: "2024-10-29 09:15",
      endTime: "2024-10-29 11:30",
      duration: "2h 15m",
      filamentUsed: "28g",
      filamentType: "PETG Preto",
      status: "completed",
      cost: "R$ 8,90"
    },
    {
      id: 3,
      jobName: "Peça de Reposição",
      startTime: "2024-10-28 16:00",
      endTime: "2024-10-28 19:20",
      duration: "3h 20m",
      filamentUsed: "38g",
      filamentType: "ABS Azul",
      status: "failed",
      cost: "R$ 0,00"
    },
    {
      id: 4,
      jobName: "Vaso Decorativo",
      startTime: "2024-10-27 10:45",
      endTime: "2024-10-27 16:30",
      duration: "5h 45m",
      filamentUsed: "72g",
      filamentType: "PLA Branco",
      status: "completed",
      cost: "R$ 18,20"
    },
    {
      id: 5,
      jobName: "Chaveiro Personalizado",
      startTime: "2024-10-26 13:20",
      endTime: "2024-10-26 14:05",
      duration: "45m",
      filamentUsed: "12g",
      filamentType: "PLA Verde",
      status: "completed",
      cost: "R$ 3,80"
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-success';
      case 'failed':
        return 'text-destructive';
      case 'cancelled':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return 'CheckCircle';
      case 'failed':
        return 'XCircle';
      case 'cancelled':
        return 'AlertCircle';
      default:
        return 'Circle';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'completed':
        return 'Concluído';
      case 'failed':
        return 'Falhou';
      case 'cancelled':
        return 'Cancelado';
      default:
        return 'Desconhecido';
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-50 transition-opacity"
        onClick={onClose}
      />
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card border border-border rounded-lg shadow-elevation-2 w-full max-w-4xl max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div className="flex items-center space-x-3">
              <Icon name="Projects" size={24} className="text-primary" />
              <div>
                <h3 className="text-xl font-semibold text-foreground">
                  Histórico de Impressões
                </h3>
                <p className="text-sm text-muted-foreground">
                  {printer?.name} - {printer?.model}
                </p>
              </div>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              iconName="X"
            />
          </div>

          {/* Stats Summary */}
          <div className="p-6 border-b border-border">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="text-center p-3 bg-muted rounded-lg">
                <div className="text-2xl font-bold text-foreground">{printer?.totalHours}h</div>
                <div className="text-sm text-muted-foreground">Total de Horas</div>
              </div>
              <div className="text-center p-3 bg-muted rounded-lg">
                <div className="text-2xl font-bold text-foreground">{printer?.completedJobs}</div>
                <div className="text-sm text-muted-foreground">Trabalhos</div>
              </div>
              <div className="text-center p-3 bg-muted rounded-lg">
                <div className="text-2xl font-bold text-foreground">195g</div>
                <div className="text-sm text-muted-foreground">Filamento Usado</div>
              </div>
              <div className="text-center p-3 bg-muted rounded-lg">
                <div className="text-2xl font-bold text-foreground">R$ 43,40</div>
                <div className="text-sm text-muted-foreground">Custo Total</div>
              </div>
            </div>
          </div>

          {/* History List */}
          <div className="overflow-y-auto max-h-96">
            <div className="p-6">
              <div className="space-y-4">
                {mockHistory?.map((job) => (
                  <div key={job?.id} className="bg-muted rounded-lg p-4 hover:bg-muted/80 transition-colors">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex-1">
                        <h4 className="font-medium text-foreground mb-1">
                          {job?.jobName}
                        </h4>
                        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                          <span>{job?.startTime}</span>
                          <span>•</span>
                          <span>{job?.duration}</span>
                        </div>
                      </div>
                      <div className={`flex items-center space-x-1 ${getStatusColor(job?.status)}`}>
                        <Icon name={getStatusIcon(job?.status)} size={16} />
                        <span className="text-sm font-medium">
                          {getStatusLabel(job?.status)}
                        </span>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
                      <div>
                        <div className="text-muted-foreground">Filamento</div>
                        <div className="font-medium text-foreground">
                          {job?.filamentUsed} - {job?.filamentType}
                        </div>
                      </div>
                      <div>
                        <div className="text-muted-foreground">Duração</div>
                        <div className="font-medium text-foreground">{job?.duration}</div>
                      </div>
                      <div>
                        <div className="text-muted-foreground">Custo</div>
                        <div className="font-medium text-foreground">{job?.cost}</div>
                      </div>
                      <div>
                        <div className="text-muted-foreground">Término</div>
                        <div className="font-medium text-foreground">{job?.endTime}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between p-6 border-t border-border">
            <div className="text-sm text-muted-foreground">
              Mostrando {mockHistory?.length} trabalhos recentes
            </div>
            <Button
              variant="outline"
              iconName="Download"
              iconPosition="left"
            >
              Exportar Histórico
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrinterHistoryModal;
